import { trackEvent } from '@site/js/utils/tracking'

const contentElement = document.querySelector('.cmp-banner-cta__content-inner')
const buttonElement = contentElement?.querySelector('.cmp-banner-cta__button')
const titleElement = contentElement?.querySelector('.cmp-banner-cta__title')
const buttonAnchorElement = buttonElement?.querySelector('.cmp-button')
const buttonTextElement = buttonElement?.querySelector('.cmp-button__text')

buttonElement?.addEventListener('click', _e => {
  trackEvent({
    event: 'interaction',
    eventSource: 'aem',
    action: 'click',
    componentName: 'pagestage-banner-cta',
    interactionType: 'button',
    text: buttonTextElement?.textContent,
    title: titleElement?.textContent.trim(),
    href: buttonAnchorElement?.href,
  })
})

document.addEventListener('DOMContentLoaded', () => {
  const pageStageElementTitle = document.querySelector('.page-stagev2 .cmp-banner-cta__title')
  const pageStageElementTitleHeading = pageStageElementTitle?.querySelector('h1')
  const hyphenClass = 'cmp-banner-cta__title--hyphen'

  if (!pageStageElementTitleHeading) {
    return
  }

  function evaluateHyphen() {
    const titleText = (pageStageElementTitleHeading.innerText || '').trim()
    const titleWords = titleText.split(/[\s-]+/)

    // Remove hyphen class first
    pageStageElementTitleHeading.classList.remove(hyphenClass)

    // Check if any individual word exceeds 16 characters
    const hasLongWord = titleText.length > 0 && titleWords.some(w => w.length > 16)

    // Check screen width less than 375px
    const isSmallScreen = typeof window !== 'undefined' && window.innerWidth < 375 && titleWords.some(w => w.length > 15)

    if (hasLongWord || isSmallScreen) {
      pageStageElementTitleHeading.classList.add(hyphenClass)
    }
  }

  // Initial evaluation
  evaluateHyphen()

  // Re-evaluate on window resize (debounced)
  let resizeTimer = null
  window.addEventListener('resize', () => {
    if (resizeTimer) {
      clearTimeout(resizeTimer)
    }
    resizeTimer = setTimeout(() => {
      evaluateHyphen()
    }, 150)
  })
})
